export default __webpack_public_path__ + "static/char-s-57-en-397647d9909b20289430438745c83213.webp";